import React from "react";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import * as jsPDF from 'jspdf';
import logo from "assets/img/Notaria/logoNot.png";

import {
  Container, Row, Col, Card, CardBody, CardTitle, CardHeader,
  Form, Button, FormGroup, Input, Table,
} from "reactstrap";

const ACTOS_MAP = {
  "1": "5d7efbd8-65b1-4edb-ae78-c120c38e7a29",
  "2": "529e1559-d146-4456-9670-7b412f2b343c",
  "3": "529e1559-d146-4456-9670-7b412f2b343c",
  "4": "9773adf4-796f-455b-9416-7fa98f287715",
  "5": "287302b9-6780-4709-8f2f-2d2edaf4fe31",
  "6": "287302b9-6780-4709-8f2f-2d2edaf4fe31",
  "7": "15b4aa9a-e168-4571-94cb-6cc3743348c5",
  "8": "c789b97d-9940-46f4-921b-9d3711bd84a3",
  "9": "b8792e4e-3ad2-4df0-afde-ab75b735ec31",
  "10": "48036ace-a20d-4d02-bdfc-e62bebb2748e",
  hipoteca_particulares: "9773adf4-796f-455b-9416-7fa98f287715",
  hipoteca_entidades: "9756339f-792e-4941-a91b-c80c0dfb8f51",
};

function CotizadorCore({ onCotizar, serviciosIniciales = [] }) {

  const [tipoEscritura, setTipoEscritura] = React.useState("");
  const [nombreActo, setNomreActo] = React.useState("");
  const [valorCuantia, setValorCuantia] = React.useState("");
  const [valorHipoteca, setValorHipoteca] = React.useState("");
  const [tCotizacion, setCotizacion] = React.useState(0);
  const [tFondo, setFondo] = React.useState(0);
  const [tSuper, setSuper] = React.useState(0);
  const [tRete, setRete] = React.useState(0);
  const [tIva, setIva] = React.useState(0);
  const [showHipoteca, setHipoteca] = React.useState(false);
  const [showCuantía, setCuantia] = React.useState(false);
  const [showDerechos, setDerechos] = React.useState(false);
  const [showStatico, setStatico] = React.useState(false);
  const [servicios, setServicios] = React.useState(serviciosIniciales);
  const [checkedRete, setCheckedRete] = React.useState(true);
  const [service_disabled] = React.useState([1]);
  const [actosDerechos, setActosDerechos] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const notaria = useSelector((state) => state.notaria.notaria);

  React.useEffect(() => {
    setServicios(serviciosIniciales);
  }, [serviciosIniciales]);

  // Helpers
  const getNumeroSeguro = (val) => {
    const n = Number(val);
    return Number.isFinite(n) ? n : 0;
  };

  const normalizarTexto = (val = "") => val.toString().trim().toLowerCase();

  const obtenerValor = (origen, campos = []) => {
    for (let i = 0; i < campos.length; i++) {
      const v = origen?.[campos[i]];
      if (v !== undefined && v !== null) return v;
    }
    return undefined;
  };

  const updateCantidad = (id, value) => {
    setServicios((prev) =>
      prev.map((item) =>
        item.id.toString() === id.toString()
          ? { ...item, cant_predet: getNumeroSeguro(value) }
          : item
      )
    );
  };

  const aplicarRespuestaCotizacion = (respuestaApi) => {
    const envelope = respuestaApi?.data || {};
    const payload = envelope?.data || envelope;
    const actosRespuesta = Array.isArray(payload?.actos) ? payload.actos : [];
    const actoCotizado = actosRespuesta[0] || {};
    const resumenActo = actoCotizado?.resumen || {};
    const resumenGeneral = payload?.resumen_general || {};
    const detalleActo = Array.isArray(actoCotizado?.detalle) ? actoCotizado.detalle : [];

    const iva = getNumeroSeguro(
      obtenerValor(resumenGeneral, ["iva"]) || obtenerValor(resumenActo, ["iva"])
    );
    const superRegistro = getNumeroSeguro(
      obtenerValor(resumenGeneral, ["super"]) || obtenerValor(actoCotizado, ["super"])
    );
    const fondo = getNumeroSeguro(
      obtenerValor(resumenGeneral, ["fondo"]) || obtenerValor(actoCotizado, ["fondo"])
    );
    const retencion = getNumeroSeguro(
      obtenerValor(resumenGeneral, ["retencion"]) || obtenerValor(resumenActo, ["retencion"])
    );
    const total = getNumeroSeguro(
      obtenerValor(resumenGeneral, ["total"]) || obtenerValor(resumenActo, ["total"])
    );

    const derechosDetalle =
      detalleActo.find((i) => normalizarTexto(i?.tarifa_tipo) === "derecho_notarial") ||
      detalleActo.find((i) => normalizarTexto(i?.concepto) === "derechos notariales");
    const derechosCant = getNumeroSeguro(obtenerValor(derechosDetalle || {}, ["cantidad"])) || 1;
    const derechosTotal = getNumeroSeguro(obtenerValor(derechosDetalle || {}, ["total"]));
    const derechosUnit = getNumeroSeguro(obtenerValor(derechosDetalle || {}, ["valor_unitario", "valor_unit", "valor"]));
    const derechos = derechosUnit || (derechosTotal > 0 ? Math.round(derechosTotal / derechosCant) : 0);

    const esMultiActo = actosRespuesta.length > 1;

    if (esMultiActo) {
      setActosDerechos(
        actosRespuesta.map((acto, idx) => {
          const det = Array.isArray(acto?.detalle) ? acto.detalle : [];
          const dd =
            det.find((i) => normalizarTexto(i?.tarifa_tipo) === "derecho_notarial") ||
            det.find((i) => normalizarTexto(i?.concepto) === "derechos notariales");
          const cant = getNumeroSeguro(obtenerValor(dd || {}, ["cantidad"])) || 1;
          const tot = getNumeroSeguro(obtenerValor(dd || {}, ["total"]));
          const unit = getNumeroSeguro(obtenerValor(dd || {}, ["valor_unitario", "valor_unit", "valor"]));
          const der = unit || (tot > 0 ? Math.round(tot / cant) : 0);
          const nombreA = obtenerValor(acto?.acto || {}, ["nombre"]) || `Acto ${idx + 1}`;
          return { nombre: `Derechos Notariales - ${nombreA}`, cantidad: cant, valor_unit: der };
        })
      );
    } else {
      setActosDerechos([]);
    }

    setIva(iva);
    setSuper(superRegistro);
    setFondo(fondo);
    setRete(retencion);
    setCotizacion(total);

    setServicios((prev) =>
      prev.map((s) => {
        if (Number(s.id) === 1) {
          return esMultiActo
            ? { ...s, cant_predet: 0, valor_unit: 0 }
            : { ...s, cant_predet: derechosCant, valor_unit: derechos };
        }
        return s;
      })
    );

    setStatico(true);
  };

  const cotizar = async () => {
    if (!tipoEscritura || typeof onCotizar !== "function") return;

    setLoading(true);

    const serviciosAdicionales = servicios
      .filter((s) => !service_disabled.includes(Number(s.id)) && getNumeroSeguro(s.cant_predet) > 0)
      .map((s) => ({ id: Number(s.id), cantidad: getNumeroSeguro(s.cant_predet) }));

    let payload;

    if (tipoEscritura === "2" || tipoEscritura === "3") {
      payload = {
        actos: [
          {
            acto_id: ACTOS_MAP["1"],
            cuantia: getNumeroSeguro(valorCuantia),
            aplica_retencion: checkedRete,
            aplica_exentos: false,
            servicios_adicionales: serviciosAdicionales,
          },
          {
            acto_id: tipoEscritura === "2" ? ACTOS_MAP["hipoteca_particulares"] : ACTOS_MAP["hipoteca_entidades"],
            cuantia: getNumeroSeguro(valorHipoteca),
            aplica_retencion: checkedRete,
            aplica_exentos: false,
            servicios_adicionales: [],
          },
        ],
      };
    } else {
      payload = {
        actos: [
          {
            acto_id: ACTOS_MAP[tipoEscritura] || tipoEscritura,
            cuantia: getNumeroSeguro(valorCuantia) + getNumeroSeguro(valorHipoteca),
            aplica_retencion: checkedRete,
            aplica_exentos: false,
            servicios_adicionales: serviciosAdicionales,
          },
        ],
      };
    }

    try {
      const respuesta = await onCotizar(payload);
      aplicarRespuestaCotizacion(respuesta);
    } catch (error) {
      console.error("Error al cotizar:", error.response?.data || error.message);
    } finally {
      setLoading(false);
    }
  };

  const selectTipoEscritura = (event) => {
    const val = event.target.value;
    setTipoEscritura(val);

    setValorCuantia("");
    setValorHipoteca("");
    setCotizacion(0);
    setIva(0);
    setSuper(0);
    setFondo(0);
    setRete(0);
    setCheckedRete(true);
    setStatico(false);
    setActosDerechos([]);
    setServicios(serviciosIniciales);

    switch (val) {
      case "1": setHipoteca(false); setCuantia(true); break;
      case "2": case "3": setHipoteca(true); setCuantia(true); break;
      case "4":
      case "5": setHipoteca(true); setCuantia(false); break;
      case "6": case "7": case "8": setHipoteca(false); setCuantia(false); break;
      case "9":
      case "10": setHipoteca(false); setCuantia(true); break;
      default: setHipoteca(false); setCuantia(false);
    }

    setDerechos(true);
  };

  const CheckedRetencion = (val) => {
    setCheckedRete(val);
    if (val) {
      setCotizacion((prev) => prev + tRete);
    } else {
      setCotizacion((prev) => prev - tRete);
    }
  };

  const formatear = (num) => {
    while (num.toString().indexOf(".") !== -1) {
      num = num.toString().replace(".", "");
    }
    num = num.toString();
    let resultado = "";
    for (var j, i = num.length - 1, j = 0; i >= 0; i--, j++)
      resultado = num.charAt(i) + (j > 0 && j % 3 === 0 ? "." : "") + resultado;
    return resultado;
  };

  const getDataUri = (url) => {
    return new Promise((resolve) => {
      var image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = this.naturalWidth;
        canvas.height = this.naturalHeight;
        var ctx = canvas.getContext("2d");
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        canvas.getContext("2d").drawImage(this, 0, 0);
        resolve(canvas.toDataURL("image/jpeg"));
      };
      image.src = url;
    });
  };

  const pdf = async () => {
    let vertical = 0;
    let horizontal = 0;
    var doc = new jsPDF({ orientation: "p", unit: "mm", format: "letter" });
    doc.setFontSize(16);
    doc.setFontType("bold");
    doc.text(String(notaria.nombre_notaria || ""), 20, 25);
    doc.setFontSize(10);
    vertical = 30;
    horizontal = 20;
    doc.setFontType("normal");
    doc.text(String(notaria.notario || ""), horizontal, vertical);
    doc.text("Nit. " + String(notaria.identificacion || ""), horizontal, vertical + 5);
    doc.text(String(notaria.direccion || ""), horizontal, vertical + 10);
    doc.text(String(notaria.telefono || ""), horizontal, vertical + 15);
    doc.text(String(notaria.regimen || ""), horizontal, vertical + 20);
    doc.line(horizontal, vertical + 23, 200, vertical + 23);
    doc.line(horizontal, vertical + 24, 200, vertical + 24);

    var urlLogo = await getDataUri(logo);
    doc.addImage(urlLogo, "JPEG", 130, 20, 60, 25);

    vertical = 60;
    doc.setFontSize(16);
    doc.setFontType("bold");
    doc.text("Cotización Previa", 100, vertical);
    doc.setFontSize(12);
    doc.setFontType("normal");
    doc.text("Acto:", horizontal + 10, vertical + 10);
    doc.text(String(nombreActo || ""), horizontal + 23, vertical + 10);
    var f = new Date();
    doc.text("Fecha: " + f.getDate() + "/" + (f.getMonth() + 1) + "/" + f.getFullYear(), horizontal + 130, vertical + 10);

    if (showCuantía) {
      doc.text("Cuantía:", horizontal + 35, vertical + 20);
      doc.text("$" + formatear(valorCuantia), horizontal + 55, vertical + 20);
    }
    if (showHipoteca) {
      doc.text("Hipoteca:", horizontal + 95, vertical + 20);
      doc.text("$" + formatear(valorHipoteca), horizontal + 115, vertical + 20);
    }

    doc.setFontType("bold");
    vertical = 90;
    horizontal = 10;
    doc.text("Servicio", horizontal + 20, vertical);
    doc.text("Cantidad", horizontal + 80, vertical, "center");
    doc.text("Precio. Uni", horizontal + 110, vertical);
    doc.text("Total", horizontal + 156, vertical);

    doc.setFontType("normal");
    vertical = 100;
    horizontal = 30;

    if (actosDerechos.length > 0) {
      actosDerechos.forEach((d) => {
        doc.text(String(d.nombre || "").slice(0, 30), horizontal, vertical);
        doc.text(String(d.cantidad), horizontal + 60, vertical);
        doc.text("$" + formatear(d.valor_unit), horizontal + 110, vertical, "right");
        doc.text("$" + formatear(d.valor_unit * d.cantidad), horizontal + 150, vertical, "right");
        vertical += 5;
      });
      servicios.filter((s) => Number(s.id) !== 1).forEach((item) => {
        doc.text(String(item.servicio_name || ""), horizontal, vertical);
        doc.text(String(item.cant_predet), horizontal + 60, vertical);
        doc.text("$" + formatear(item.valor_unit), horizontal + 110, vertical, "right");
        doc.text("$" + formatear(item.valor_unit * item.cant_predet), horizontal + 150, vertical, "right");
        vertical += 5;
      });
    } else {
      servicios.forEach((item) => {
        doc.text(String(item.servicio_name || ""), horizontal, vertical);
        doc.text(String(item.cant_predet), horizontal + 60, vertical);
        doc.text("$" + formatear(item.valor_unit), horizontal + 110, vertical, "right");
        doc.text("$" + formatear(item.valor_unit * item.cant_predet), horizontal + 150, vertical, "right");
        vertical += 5;
      });
    }

    vertical += 10;
    doc.text("Iva:", horizontal + 110, vertical, "right");
    doc.text("$" + formatear(tIva), horizontal + 150, vertical, "right");
    vertical += 5;
    doc.text("Super:", horizontal + 110, vertical, "right");
    doc.text("$" + formatear(tSuper), horizontal + 150, vertical, "right");
    vertical += 5;
    doc.text("Fondo:", horizontal + 110, vertical, "right");
    doc.text("$" + formatear(tFondo), horizontal + 150, vertical, "right");
    vertical += 5;
    if (checkedRete) {
      doc.text("Retención:", horizontal + 110, vertical, "right");
      doc.text("$" + formatear(tRete), horizontal + 150, vertical, "right");
      vertical += 5;
    }
    doc.setFontType("bold");
    doc.text("Gran Total:", horizontal + 110, vertical, "right");
    doc.text("$" + formatear(tCotizacion), horizontal + 150, vertical, "right");

    vertical = 200;
    doc.line(20, vertical, 200, vertical);
    doc.setFontSize(10);
    doc.text("*La presente es una liquidación COTIZACIÓN PROVISIONAL el cual puede variar ostensiblemente con la ", 15, vertical + 5);
    doc.text("liquidación real al momento de otorgar la escritura pública. Generado por Sinfony", 15, vertical + 8);
    doc.save("Cotización.pdf");
  };

  return (
    <>
      <div id="cotizar" style={{ backgroundColor: "#f9f9f9", marginTop: "10%" }}>
        <Container className="fluid">
          <Row>
            <Col className="ml-auto mr-auto" lg="4" style={{ marginTop: "30px" }}>
              <Card className="card-profile" style={{ borderRadius: "15px" }}>
                <div className="card-avatar">
                  <a href="#pablo" onClick={(e) => e.preventDefault()}>
                    <img
                      alt="tres manos realizando los calculos para una cotización"
                      className="img img-raised"
                      src={require("assets/img/Notaria/coti.jpg")}
                    />
                  </a>
                </div>
                <CardTitle tag="h3">Seleccionar: </CardTitle>
                <CardBody style={{ marginBottom: "20px" }}>
                  <FormGroup>
                    <select
                      className="form-control"
                      id="Select1"
                      value={tipoEscritura}
                      onChange={selectTipoEscritura}
                    >
                      <option style={{ color: "#a8a6a6", fontSize: "16px" }}>Elija el tipo de acto:</option>
                      <option value="1">Compra Venta</option>
                      <option value="2">Compra Venta e hipoteca con particulares</option>
                      <option value="3">Compra Venta e Hipoteca con entidades financieras</option>
                      <option value="4">Hipoteca</option>
                      <option value="5">Cancelación de hipoteca con particulares</option>
                      <option value="6">Cancelación de hipoteca con entidades financieras</option>
                      <option value="7">Matrimonio Civil en la notaría</option>
                      <option value="8">Matrimonio Civil a domicilio</option>
                      <option value="9">Sucesiones</option>
                      <option value="10">Liquidación de sociedad conyugal</option>
                    </select>
                  </FormGroup>
                </CardBody>
              </Card>
            </Col>

            {showDerechos && (
              <Col className="ml-auto mr-auto" lg="8" style={{ marginTop: "30px" }}>
                <Card className="card-profile text-center" style={{ borderRadius: "15px" }}>
                  <CardBody>
                    <CardTitle tag="h4">
                      {(showCuantía || showHipoteca) ? "Ingresar el valor: " : "Confirmar cotización"}
                    </CardTitle>
                    <Form>
                      <Row className="justify-content-center">
                        {showCuantía && (
                          <Col sm="6">
                            <FormGroup>
                              <label><b>Cuantía</b></label>
                              <Input
                                id="valor_cuantia"
                                onChange={(e) => setValorCuantia(e.target.value)}
                                type="number"
                                value={valorCuantia}
                              />
                              <br />
                              <label className="text-center">
                                <b>Valor Cuantía: $ </b>{formatear(valorCuantia)}
                              </label>
                            </FormGroup>
                          </Col>
                        )}
                        {showHipoteca && (
                          <Col sm="6">
                            <FormGroup>
                              <label><b>Hipoteca</b></label>
                              <Input
                                id="valor_hipoteca"
                                onChange={(e) => setValorHipoteca(e.target.value)}
                                type="number"
                                value={valorHipoteca}
                              />
                              <br />
                              <label className="text-center">
                                <b>Valor Hipoteca: $ </b>{formatear(valorHipoteca)}
                              </label>
                            </FormGroup>
                          </Col>
                        )}
                      </Row>
                    </Form>
                    <Button
                      onClick={cotizar}
                      color="azul"
                      disabled={loading}
                      style={{ marginTop: "-2px", marginBottom: "-4px", minWidth: "100px" }}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm" role="status" style={{ marginRight: "8px" }} />
                          Calculando...
                        </>
                      ) : (
                        <b style={{ fontSize: "14px" }}>Cotizar</b>
                      )}
                    </Button>
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>

          <Row>
            {showStatico && (
              <Col lg="12">
                <Card id="pdfdiv" style={{ borderRadius: "15px" }}>
                  <CardHeader>
                    <h2 className="info-title text-center" style={{ marginTop: "20px" }}><b>Cotización</b></h2>
                    <h6 className="text-center" style={{ color: "#da251c" }}>
                      *La presente es una liquidación COTIZACIÓN PROVISIONAL el cual puede variar ostensiblemente con la liquidación real al momento de otorgar la escritura pública
                    </h6>
                  </CardHeader>
                  <CardBody>
                    <Table striped className="text-center">
                      <thead>
                        <tr>
                          <th style={{ color: "#1c6e38" }}>Servicios</th>
                          <th style={{ color: "#1c6e38" }}>Cantidad</th>
                          <th style={{ color: "#1c6e38" }}>Precio Unitario</th>
                          <th style={{ color: "#1c6e38" }}>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {actosDerechos.map((d, idx) => (
                          <tr key={`derecho-${idx}`}>
                            <td>{d.nombre}</td>
                            <td>
                              <Row className="justify-content-center">
                                <Col sm="6">
                                  <FormGroup>
                                    <Input disabled value={d.cantidad} type="number" />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </td>
                            <td>{"$" + formatear(d.valor_unit)}</td>
                            <td>{"$" + formatear(d.valor_unit * d.cantidad)}</td>
                          </tr>
                        ))}

                        {(actosDerechos.length > 0
                          ? servicios.filter((s) => Number(s.id) !== 1)
                          : servicios
                        ).map((item) => (
                          <tr key={uuidv4()}>
                            <td>{item.servicio_name}</td>
                            <td>
                              <Row className="justify-content-center">
                                <Col sm="6">
                                  <FormGroup>
                                    <Input
                                      id={item.id.toString()}
                                      disabled={service_disabled.includes(item.id)}
                                      defaultValue={item.cant_predet}
                                      onChange={(e) => updateCantidad(e.target.id, e.target.value)}
                                      type="number"
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </td>
                            <td>{"$" + formatear(item.valor_unit)}</td>
                            <td>{"$" + formatear(item.valor_unit * item.cant_predet)}</td>
                          </tr>
                        ))}

                        <tr>
                          <td></td><td></td>
                          <td><b>IVA</b></td>
                          <td>{"$" + formatear(tIva)}</td>
                        </tr>
                        <tr>
                          <td></td><td></td>
                          <td><b>Super</b></td>
                          <td>{"$" + formatear(tSuper)}</td>
                        </tr>
                        <tr>
                          <td></td><td></td>
                          <td><b>Fondo</b></td>
                          <td>{"$" + formatear(tFondo)}</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td>
                            <b>Retención</b>
                            <Input
                              type="switch"
                              color="primary"
                              id="exampleCustomSwitch"
                              name="customSwitch"
                              label="SI (Retención)"
                              checked={checkedRete}
                              onChange={(event) => CheckedRetencion(event.target.checked)}
                              value="checkedA"
                              plaintext="true"
                            />
                          </td>
                          <td>{checkedRete && "$" + formatear(tRete)}</td>
                        </tr>
                        <tr>
                          <td></td><td></td>
                          <td><b>Total Cotización</b></td>
                          <td>{"$" + formatear(tCotizacion)}</td>
                        </tr>
                      </tbody>
                    </Table>

                    <Row>
                      <Col sm="12" className="text-center">
                        <h5 className="info-title text-center" style={{ marginTop: "10px" }}>
                          <b>Nota: </b>
                          <i>Retención <b style={{ color: "#da251c" }}>SI</b> para Persona Natural y <b style={{ color: "#da251c" }}>NO</b> para Persona Jurídica.</i>
                        </h5>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="12" className="text-center">
                        <Button onClick={pdf} color="azul">
                          <b style={{ fontSize: "14px" }}>Imprimir</b>
                        </Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </>
  );
}

export default CotizadorCore;